module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-08b5c3e8!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/view/index/App.vue
// module id = 1071
// module chunks = 99